import { render, staticRenderFns } from "./DoughnutChartFooterItem.vue?vue&type=template&id=39fd2b1a&scoped=true"
import script from "./DoughnutChartFooterItem.vue?vue&type=script&lang=js"
export * from "./DoughnutChartFooterItem.vue?vue&type=script&lang=js"
import style0 from "./DoughnutChartFooterItem.vue?vue&type=style&index=0&id=39fd2b1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fd2b1a",
  null
  
)

export default component.exports